import { ApiClient } from '../../../../infra';
import { fromBackend } from '../../../../domain';
/** O cadastro como o painel o le: criacao e alteracao no fuso de quem olha. */
function companyFromBackend(company) {
    return { ...company, createdAt: fromBackend(company.createdAt), updatedAt: fromBackend(company.updatedAt) };
}
/**
 * Tudo o que se pergunta ao servidor sobre uma empresa.
 *
 * Mora na pasta do CONCEITO. A empresa e pedida por mais de uma tela - a lista, os
 * dois dialogos dela, "Meus Dados" e o seletor que varias montam -, e isso um dia
 * justificou um servico geral. Nao justifica: o place de conceito e a casa do
 * assunto, e quem consome de fora importa DELE, que e uma dependencia legivel
 * ("Meus Dados usa empresa") em vez de uma pasta tecnica.
 */
export class CompanyApi {
    constructor() {
        this.client = ApiClient.INSTANCE;
    }
    static { this.INSTANCE = new CompanyApi(); }
    async fetchCompany(id) {
        return companyFromBackend((await this.client.send('GET', `/v2/companies/${id}`)));
    }
    /**
     * As empresas que casam com um termo, uma PAGINA por vez.
     *
     * `GET /v2/companies/options`, com sessao e so para admin - distinto do `/active`, que
     * e publico, serve ao cadastro e devolve a lista inteira. Aqui o seletor pergunta
     * conforme se digita, entao trazer tudo seria trazer a base de clientes a cada
     * tela aberta.
     *
     * O termo casa com nome fantasia, razao social e CNPJ.
     */
    async searchCompanies(term, page, size, signal) {
        const query = new URLSearchParams();
        if (term.trim()) {
            query.set('q', term.trim());
        }
        query.set('page', String(Math.max(0, page)));
        query.set('size', String(size));
        return (await this.client.send('GET', `/v2/companies/options?${query}`, undefined, signal));
    }
    /**
     * Uma PAGINA da tabela de Empresas, filtrada e ordenada no servidor.
     *
     * Antes a tela pedia `GET /v2/companies` - a lista inteira - e filtrava, ordenava e
     * paginava no navegador. Isso para de funcionar quando o cliente tiver algumas
     * centenas de empresas, e ja custava um SELECT por empresa no servidor so para
     * contar os usuarios de cada uma.
     *
     * `sort` e o nome da coluna com `-` para descendente, a mesma gramatica do
     * endereco; o servidor so aceita os nomes que conhece.
     */
    async searchCompanyPage(criteria, page, size, signal) {
        const found = (await this.client.send('POST', '/v2/companies/search', { searchParameters: criteria, page: { number: Math.max(0, page), size } }, signal));
        return { ...found, elements: (found.elements ?? []).map(companyFromBackend) };
    }
    /**
     * O catalogo de segmentos, por onde o ICP classifica as empresas.
     *
     * So o administrador geral le (`ROLE_ADMIN` no servidor) - e o unico que escolhe o
     * segmento no formulario.
     */
    async fetchSegments() {
        return ((await this.client.send('GET', '/v2/catalogs/company-segments')) ?? []);
    }
    async createCompany(input) {
        return companyFromBackend((await this.client.send('POST', '/v2/companies', input)));
    }
    /**
     * O CNPJ VAI, e so o super admin consegue mudar de verdade.
     *
     * Ele e valor chave: o backend aceita o campo no update mas recusa com 403 quem
     * nao for super admin, e so quando o valor difere do gravado - repetir o atual
     * nao e mudanca. Como a tela de Empresas ja e exclusiva de admin, na pratica
     * quem chega aqui pode; o admin de EMPRESA edita a propria por Meus Dados, onde
     * o campo e somente leitura e nao entra no corpo.
     */
    async updateCompany(id, input) {
        return companyFromBackend((await this.client.send('PUT', `/v2/companies/${id}`, input)));
    }
    async deactivateCompany(id) {
        await this.client.send('POST', `/v2/companies/${id}/deactivate`);
    }
    /**
     * Libera o acesso de uma empresa bloqueada - so o administrador geral.
     *
     * Ate 08/10/2026 era um PUT com `active: true`, que qualquer administrador da
     * empresa alcancava: a empresa se desbloqueava pela edicao de cadastro. Agora o
     * backend so aceita mudar o status pelo administrador geral, e por este caminho.
     */
    async activateCompany(id) {
        await this.client.send('POST', `/v2/companies/${id}/activate`);
    }
    /**
     * As tentativas de entrar no painel recusadas pelo bloqueio da empresa.
     *
     * O administrador geral ve sempre; o administrador principal (master) da empresa ve
     * quando ela esta ativa. Para os outros o backend responde 403, e por isso o
     * chamador marca o papel em jogo: a recusa nao e sessao perdida.
     */
    async fetchBlockedSignInAttempts(id) {
        const attempts = ((await this.client.send('GET', `/v2/companies/${id}/blocked-sign-in-attempts`, undefined, undefined, {
            roleAtStake: true
        })) ?? []);
        return attempts.map((attempt) => ({ ...attempt, attemptedAt: fromBackend(attempt.attemptedAt) }));
    }
    async deleteCompany(id) {
        await this.client.send('DELETE', `/v2/companies/${id}`);
    }
}
//# sourceMappingURL=companies.api.js.map